"use client";

import { CONTACT_INQUIRY_TURNSTILE_ACTION } from "@klarify/constants";
import { Turnstile, type TurnstileInstance } from "@marsidev/react-turnstile";
import { useRef } from "react";

interface Props {
	siteKey: string;
	onToken: (token: string) => void;
	onExpire: () => void;
}

export const TurnstileWidget = ({ siteKey, onToken, onExpire }: Props) => {
	const ref = useRef<TurnstileInstance | null>(null);
	return (
		<Turnstile
			ref={ref}
			siteKey={siteKey}
			onSuccess={onToken}
			onExpire={onExpire}
			options={{
				theme: "light",
				appearance: "interaction-only",
				// Labels the challenge in Cloudflare analytics and gets echoed back
				// in siteverify so the server can refuse tokens issued for a
				// different widget (defense in depth — also surfaced in the
				// dashboard's per-action breakdown).
				action: CONTACT_INQUIRY_TURNSTILE_ACTION,
			}}
		/>
	);
};
